import * as React from "react";
import { Path, G, ClipPath, Defs, Rect, Mask } from "react-native-svg";

import { Icon, IconProps } from "../../primitive";

export const SIIcon = (props: IconProps) => (
  <Icon fill="none" viewBox="0 0 16 12" title="SI" {...props}>
    <G clipPath="url(#a)">
      <Rect width={16} height={12} fill="#fff" rx={1} />
      <Path
        fill="#2E42A5"
        fillRule="evenodd"
        d="M0 0v12h16V0H0Z"
        clipRule="evenodd"
      />
      <Mask
        id="b"
        width={16}
        height={12}
        x={0}
        y={0}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: "luminance",
        }}
      >
        <Path
          fill="#fff"
          fillRule="evenodd"
          d="M0 0v12h16V0H0Z"
          clipRule="evenodd"
        />
      </Mask>
      <G mask="url(#b)">
        <Path
          fill="#F7FCFF"
          fillRule="evenodd"
          d="M0 0v4h16V0H0Z"
          clipRule="evenodd"
        />
        <Path
          fill="#C51918"
          fillRule="evenodd"
          d="M0 8v4h16V8H0Z"
          clipRule="evenodd"
        />
        <Path
          fill="#2E42A5"
          fillRule="evenodd"
          d="M6.87 2.518s-1.052-.497-2.361-.497c-1.31 0-2.361.497-2.361.497s.117 1.997.302 3.055c.079.452.459 1.111.803 1.423.392.355 1.256.777 1.256.777.25-.173.718-.25 1.315-.777.598-.527.747-1.423.747-1.423l.3-3.055Z"
          clipRule="evenodd"
        />
        <Path
          fill="#C51918"
          d="m6.731 2.453.438.219-.3 3.01c-.106.638-.37 1.14-.791 1.512a3.422 3.422 0 0 1-.692.478c-.135.07-.7.361-.695.36-.057.026-.1.05-.134.074l-.055.038-.06-.029c-.584-.285-1.13-.669-1.402-.915-.37-.336-.761-1.024-.844-1.5-.125-.711-.237-1.692-.315-3.029l.394-.205c.077 1.326.171 2.384.294 3.082.072.414.432 1.048.76 1.346.244.22.635.465 1.173.73.032-.019.068-.037.108-.057.001 0 .367-.163.495-.23.223-.116.43-.256.643-.444.375-.33.608-.774.703-1.339l.28-3.101Z"
        />
        <Path
          fill="#fff"
          d="M5.075 6.5a.229.229 0 0 1 .133.032c.131.072.282.114.42.121-.033.042-.063.083-.095.12-.373.418-1.027.62-1.042.624 0 0-.56-.215-1.011-.656l-.03-.031c.12.004.207-.027.263-.099.034-.042.135-.084.25-.101a.585.585 0 0 1 .143-.007.16.16 0 0 1 .039.009c.097.145.345.222.578.125l-.03.006c.081-.028.226-.094.238-.1a.472.472 0 0 1 .144-.043Zm.123-.353a.314.314 0 0 1 .164.035c.159.075.344.12.507.12a5.021 5.021 0 0 1-.109.167c-.127.028-.322-.009-.48-.095a.376.376 0 0 0-.217-.05.604.604 0 0 0-.191.056l-.206.092.028-.005c-.198.076-.372.019-.421-.063-.089-.145-.551-.074-.682.093-.034.045-.138.05-.31.008a2.738 2.738 0 0 1-.117-.167c.224.04.377.02.461-.074.04-.045.16-.089.294-.107a.795.795 0 0 1 .171-.007.226.226 0 0 1 .05.01c.004.001.003 0-.002-.007.103.149.385.229.65.132l-.025.005c.084-.026.247-.091.263-.098a.618.618 0 0 1 .172-.045Zm-.128-1.1.348-.378.878.843s-.133.284-.317.605a1.018 1.018 0 0 1-.553-.097.462.462 0 0 0-.239-.048.748.748 0 0 0-.213.053c-.017.007-.18.073-.236.093l.025-.005c-.228.078-.437.02-.496-.066-.096-.139-.612-.07-.757.093-.05.056-.208.057-.468-.011-.175-.327-.271-.617-.271-.617l.862-.843.372.379.486-.826.579.826Z"
        />
        <Path
          fill="#FECA00"
          fillRule="evenodd"
          d="M3.573 2.943h-.351l.273-.255-.273-.27h.351l.149-.262.149.262h.35l-.258.253.23.272H3.87l-.15.277-.148-.277ZM5.23 2.943H4.88l.272-.255-.272-.27h.351l.149-.262.149.262h.35l-.258.253.23.272h-.322l-.15.277-.148-.277ZM4.3 3.783h-.352l.273-.255-.273-.27H4.3l.148-.262.15.262h.35l-.259.254.23.271h-.322l-.149.277-.148-.277Z"
          clipRule="evenodd"
        />
      </G>
    </G>
    <Defs>
      <ClipPath id="a">
        <Rect width={16} height={12} fill="#fff" rx={1} />
      </ClipPath>
    </Defs>
  </Icon>
);
